import { Button, DatePicker, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const { RangePicker } = DatePicker;

export const CUSTOM_PRESET_KEY = 'custom';

export default function AdminAnalyticsQueryBar({
    title,
    hint,
    presets,
    dateRange,
    onDateRangeChange,
    activePresetKey,
    onPresetChange,
    onRun,
    runLabel = 'Run',
    loading = false,
    filters = null
}) {
    const presetOptions = [
        ...presets.map((preset) => ({ value: preset.key, label: preset.label })),
        { value: CUSTOM_PRESET_KEY, label: 'Custom range' }
    ];

    return (
        <div className="admin-analytics-bar">
            <div className="admin-analytics-bar__row">
                <div className="admin-analytics-bar__meta">
                    <span className="admin-analytics-bar__title">{title}</span>
                    {hint && <span className="admin-analytics-bar__hint">{hint}</span>}
                </div>
                <div className="admin-analytics-bar__controls">
                    <Select
                        size="small"
                        value={activePresetKey || CUSTOM_PRESET_KEY}
                        options={presetOptions}
                        onChange={onPresetChange}
                        disabled={loading}
                        popupMatchSelectWidth={false}
                        className="admin-analytics-bar__preset"
                    />
                    <RangePicker
                        size="small"
                        value={dateRange}
                        onChange={onDateRangeChange}
                        allowClear={false}
                        format="MMM D, YYYY"
                        className="admin-analytics-bar__range"
                    />
                    <Button type="primary" size="small" onClick={onRun} loading={loading}>
                        {runLabel}
                    </Button>
                    {filters}
                </div>
            </div>
        </div>
    );
}

AdminAnalyticsQueryBar.propTypes = {
    title: PropTypes.string.isRequired,
    hint: PropTypes.string,
    presets: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    dateRange: PropTypes.array,
    onDateRangeChange: PropTypes.func.isRequired,
    activePresetKey: PropTypes.string,
    onPresetChange: PropTypes.func.isRequired,
    onRun: PropTypes.func.isRequired,
    runLabel: PropTypes.string,
    loading: PropTypes.bool,
    filters: PropTypes.node
};
